import Swiper, { Autoplay, Zoom, Thumbs } from 'swiper';
import 'swiper/swiper-bundle.css'
import './index.scss'
import './zoom.js'
import './add_to_cart'

Swiper.use([Autoplay, Zoom, Thumbs])

let swiper_reviews = new Swiper(".product_reviews_content", {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 50,
    observer: true,
    observeParents: true,
    speed: 1500,
    autoplay: {
        delay: 4500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
});

if (window.location.search.replace('?section=', '') == 'reviews') {
    let current = document.querySelectorAll('.product_reviews_item').length - 1
    swiper_reviews.slideTo(current, 100, false)
}

let swiper = new Swiper(".main_slider", {
    slidesPerView: 1,
    slidesPerGroup: 1,
    initialSlide: 0,
    zoom: {
        maxRaito: 5,
        minRaito: 1
    },
    thumbs: {
        swiper: {
            el: ".mini-slider",
            slidesPerView: 3,
            spaceBetween: 20,
            breakpoints: {
                500: {
                    slidesPerView: 3,
                },
                300: {
                    slidesPerView: 2,
                },
            },
        }
    }
});

if (window.location.search.replace('?section=', '') == 'reviews') {
    document.querySelectorAll('.product_info_sections_content > div').forEach(div => div.style.display = 'none')
    document.querySelectorAll('.product_sections__item').forEach(item => item.classList.remove('item_selected'))

    document.querySelector('.product_reviews_content').style.display = 'block'
    document.querySelector('.product_reviews').classList.add('item_selected')
}

document.querySelector('.product_info_sections').addEventListener('click', (e) => {
    document.querySelectorAll('.product_info_sections_content > div').forEach(div => div.style.display = 'none')
    document.querySelectorAll('.product_sections__item').forEach(item => item.classList.remove('item_selected'))
    if (e.target.classList.contains('product_description')) {
        document.querySelector('.product_description_content').style.display = 'block'
        document.querySelector('.product_description').classList.add('item_selected')
    }
    else if (e.target.classList.contains('product_specifications')) {
        document.querySelector('.product_specifications_content').style.display = 'block'
        document.querySelector('.product_specifications').classList.add('item_selected')
    }
    else if (e.target.classList.contains('product_reviews')) {
        document.querySelector('.product_reviews_content').style.display = 'block'
        document.querySelector('.product_reviews').classList.add('item_selected')
    }
})

document.querySelectorAll('.btn-add').forEach(btn => btn.addEventListener('click', (e) => {
    let product = {
        item_id: btn.dataset.id,
        quantity: document.querySelector('.product_quantity__value').textContent,
        size: (document.querySelector('.active[data-size]')) ? document.querySelector('.active[data-size]').dataset.size : '',
    }

    if (!btn.classList.contains('selected')) {
        fetch('/api/cart_items/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                "Accept": "application/json"
            },
            body: JSON.stringify(product) 
        })
            .then(response => {
                response.json()
                if (response.ok) {
                    document.querySelector('.btn-add.hidden').classList.toggle('hidden')
                    btn.classList.toggle('hidden')
                    if (document.querySelector('.header_basket_count')) {
                        document.querySelector('.header_basket_count').textContent = +document.querySelector('.header_basket_count').textContent + 1
                    }
                    if (document.querySelector('.header_basket_count-mob')) {
                        document.querySelector('.header_basket_count-mob').textContent = +document.querySelector('.header_basket_count-mob').textContent + 1
                    }
                    window.location.reload()
                }
            })
    }
    // if (btn.classList.contains('selected')) {
    //     fetch(`/api/cart_item/${product.item_id}`, {
    //         method: 'DELETE',
    //     })
    //         .then(response => {
    //             response.json()
    //             if (response.ok) {
    //                 document.querySelector('.btn-add.hidden').classList.toggle('hidden')
    //                 btn.classList.toggle('hidden')
    //                 if (document.querySelector('.header_basket_count')) {
    //                     document.querySelector('.header_basket_count').textContent = +document.querySelector('.header_basket_count').textContent - 1
    //                 }
    //             }
    //         })
    // }
}))



document.querySelectorAll('.product_reviews_votes > button').forEach(btn => {
    btn.addEventListener('click', () => {
        let param = {
            review_id: btn.dataset.review_id,
            rating: true,
        }
        if (btn.classList.contains('btn_like')) {
            if (!btn.classList.contains('active')) {
                fetch(`/api/review_rating/?review_id=${param.review_id}&rating=${param.rating}`, {
                    method: 'POST',
                })
                .then(response => {
                    response.json()
                    if (response.ok) {
                        btn.parentNode.querySelector('.like_count').textContent = +btn.parentNode.querySelector('.like_count').textContent + 1
                        btn.classList.add('active')
                        if (btn.parentNode.querySelector('.btn_dislike').classList.contains('active')) {
                            btn.parentNode.querySelector('.dislike_count').textContent = +btn.parentNode.querySelector('.dislike_count').textContent - 1
                            btn.parentNode.querySelector('.btn_dislike').classList.remove('active')
                        }
                    }
                })
            }
            else {
                fetch(`/api/review_rating/?review_id=${param.review_id}&rating=${param.rating}`, {
                    method: 'POST',
                })
                .then(response => {
                    response.json()
                    if (response.ok) {
                        btn.parentNode.querySelector('.like_count').textContent = +btn.parentNode.querySelector('.like_count').textContent - 1
                        btn.classList.remove('active')
                    }
                })
            }
        }
        else if (btn.classList.contains('btn_dislike')) {
            param.rating = false
            if (!btn.classList.contains('active')) {
                fetch(`/api/review_rating/?review_id=${param.review_id}&rating=${param.rating}`, {
                    method: 'POST',
                })
                .then(response => {
                    response.json()
                    if (response.ok) {
                        btn.parentNode.querySelector('.dislike_count').textContent = +btn.parentNode.querySelector('.dislike_count').textContent + 1
                        btn.classList.add('active')
                        if (btn.parentNode.querySelector('.btn_like').classList.contains('active')) {
                            btn.parentNode.querySelector('.like_count').textContent = +btn.parentNode.querySelector('.like_count').textContent - 1
                            btn.parentNode.querySelector('.btn_like').classList.remove('active')
                        }
                    }
                })
            }
            else {
                fetch(`/api/review_rating/?review_id=${param.review_id}&rating=${param.rating}`, {
                    method: 'POST',
                })
                .then(response => {
                    response.json()
                    if (response.ok) {
                        btn.parentNode.querySelector('.dislike_count').textContent = +btn.parentNode.querySelector('.dislike_count').textContent - 1
                        btn.classList.remove('active')
                    }
                })
            }
        }
    })
})


document.querySelectorAll('.add_answer').forEach(btn => {
    btn.addEventListener('click', () => {
        document.querySelector('#review_id').value = btn.dataset.review_id
    })
})

if (document.querySelector('.add_review__btn')) {
    document.querySelector('.add_review__btn').addEventListener('click', () => {
        document.querySelector('.add_review_form_wrapper').classList.toggle('active')
        document.querySelector('.product_reviews_content_wrapper').classList.toggle('active')
        document.querySelector('.add_review__btn').classList.toggle('active')
        document.querySelector('.answer_form_wrapper').classList.remove('active')
    })
}


document.querySelectorAll('.add_answer').forEach(btn => {
    btn.addEventListener('click', () => {
        document.querySelector('.answer_form_wrapper').classList.toggle('active')
    })
})


document.querySelector('.rating-area').addEventListener('click', () => {
    document.querySelector('#product_rating').value = document.querySelector('.rating-area > input:checked').value
    console.log(document.querySelector('#product_rating').value);
})


let size = document.querySelector('.product_info_size__value')

if (size) {
    size.addEventListener('click', (e) => {
        if (e.target.tagName === 'SPAN') {
            size.querySelectorAll('.active').forEach(size_item => size_item.classList.remove('active'))
            e.target.classList.add('active')
        }
    })
}
